import { ChangeDetectorRef, Component, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { safelyDetectChanges } from 'src/app/common/app.helpers';
import { setDropdownWidth } from 'src/app/forms/forms.helpers';
import { FieldAttribute, SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { FormFieldSate } from '../form-field.state';

@Component({
  selector: 'app-select-form-field',
  templateUrl: './select-form-field.component.html',
  styleUrls: ['./select-form-field.component.scss'],
})
export class SelectFormFieldComponent extends FormFieldSate {
  @Input({ required: true }) public attr: FieldAttribute = undefined;
  @Input({ required: true }) public searchForm: UntypedFormGroup;

  public isDisabled = false;
  public selectedItem = '';

  @Output() private searchValue: EventEmitter<SelectorOption> = new EventEmitter<SelectorOption>();

  private translateService = inject(TranslateService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  public override ngOnInit(): void {
    if (this.attr) {
      this.fieldAttribute = this.attr;
      this.form = this.searchForm;
      this.detectChanges();
    } else {
      super.ngOnInit();
      this.updateControlValue(this.fieldAttribute.options);
    }
  }

  @HostListener('click')
  public clickControl(): void {
    setDropdownWidth('.form-select');
  }

  @HostListener('window:resize')
  public resizeWindow(): void {
    setDropdownWidth('.form-select');
  }

  protected override initField(): void {
    this.control = this.formStateService.initControl(this.form, this.fieldAttribute);
    this.detectChanges();
  }

  public selectCurrentValue(currentValue: SelectorOption): void {
    if (this.fieldAttribute.backendAttribute.name === 'search') {
      this.searchValue.emit(currentValue);
      this.selectedItem = this.translateService.instant(currentValue.title) as string;
      this.detectChanges();
      return;
    }

    if ((this.control.value as string) === currentValue.entity_id) {
      return;
    }

    this.control.setValue(currentValue.entity_id);
    this.selectedItem = this.translateService.instant(currentValue.title) as string;
    this.detectChanges();
  }

  private detectChanges(): void {
    safelyDetectChanges(this.changeDetectorRef);
  }

  private updateControlValue(options: SelectorOption[]): void {
    if (this.control.value as string) {
      const inputValue: string = options.find((item: SelectorOption) => item.entity_id === this.control.value)['title'];
      this.selectedItem = this.translateService.instant(inputValue) as string;
      this.detectChanges();
    }
  }
}
